import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_CENTRE_REQUEST = 'FETCH_CENTRE_REQUEST';
export const FETCH_CENTRE_SUCCESS = 'FETCH_CENTRE_SUCCESS';
export const FETCH_CENTRE_FAILURE = 'FETCH_CENTRE_FAILURE';

const buildFetchCentreUrl = (centreId) => buildUrl(`/centres/${centreId}`);
const method = 'GET';

export function fetchCentreIfNeeded(centreId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method, url: buildFetchCentreUrl(centreId) })) {
      return false;
    }

    return dispatch(fetchCentre(centreId));
  };
}

export function fetchCentre(centreId) {
  return (dispatch) => {
    const url = buildFetchCentreUrl(centreId);

    return dispatch(fetchCentreRequest()).payload
      .then((response) => dispatch(fetchCentreSuccess(response)))
      .catch((error) => dispatch(fetchCentreFailure(error)));

    function fetchCentreRequest() {
      return ApiCall.createAction({
        type: FETCH_CENTRE_REQUEST,
        payload: fetch(url),
        url,
        method,
        centreId,
      });
    }

    function fetchCentreSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_CENTRE_SUCCESS,
        payload: response,
        url,
        method,
        centreId,
      });
    }

    function fetchCentreFailure(error) {
      return ApiCall.createAction({
        type: FETCH_CENTRE_FAILURE,
        error,
        url,
        method,
        centreId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Centre/actions.js